
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import Head from "next/head";
import useTranslation from "next-translate/useTranslation";
import { Container } from "../../../components/util/container";
import { Section } from "../../../components/util/section";
import Posts from "../../../components/blog/BlogPosts";
import Header from "../../../components/blog/Header";
import { client } from "../../../../tina/__generated__/client";
const MIN_INDEXABLE_CATEGORY_POSTS = 3;
export default function GuideCategory({ category, posts }) {
    const { t } = useTranslation("common");
    if (!category) {
        return null;
    }
    const shouldNoindex = posts.length < MIN_INDEXABLE_CATEGORY_POSTS;
    return (<Section className="flex-1">
      {shouldNoindex && (<Head>
          <meta name="robots" content="noindex,follow"/>
        </Head>)}
      <Header>
        <h2 className="relative w-full mb-4 text-3xl font-extrabold tracking-normal text-center text-white md:text-5xl title-font">
          {t(category.category)}
        </h2>
        <div className="max-w-2xl mx-auto text-sm font-normal text-center text-gray-300 md:text-base">
          {category.description}
        </div>
      </Header>
      <Container size="medium" width="small">
        {posts.length > 0 ? (<Posts data={posts} groupBySubtopic mode="guides"/>) : (<div className="px-6 py-8 mt-10 text-sm text-gray-600 bg-white border border-slate-200 rounded-xl">
            New guides for this topic are coming soon.
          </div>)}
      </Container>
    </Section>);
}
export const getStaticPaths = async () => {
    const categoryConnection = await client.queries.categoryConnection();
    const categories = categoryConnection.data.categoryConnection.edges;
    const paths = categories
        .filter((category) => category.node._sys.filename !== "news")
        .map((category) => ({
        params: {
            category: category.node._sys.filename,
        },
        locale: "en",
    }));
    return {
        paths,
        fallback: true,
    };
};
const getStaticProps = async ({ params }) => {
    const { category: categorySlug } = params;
    if (categorySlug === "news") {
        return {
            redirect: {
                destination: "/news",
                permanent: true,
            },
        };
    }
    const postsResponse = await client.queries.postConnection({
        filter: {
            locale: { eq: "en" },
            category: {
                category: {
                    slug: { eq: categorySlug },
                },
            },
        },
    });
    const posts = postsResponse.data.postConnection.edges;
    const variables = {
        relativePath: `${categorySlug}.md`,
    };
    const props = await client.queries.category(variables);
    const category = props.data.category;
    if (!category) {
        return {
            notFound: true,
        };
    }
    return {
        props: {
            posts,
            category,
        },
    };
};

    async function __Next_Translate__getStaticProps__1a042aa3e49__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/guides/[category]/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a042aa3e49__ as getStaticProps }
  